import { render, staticRenderFns } from "./TableComp.vue?vue&type=template&id=0fbc1a6a"
import script from "./TableComp.vue?vue&type=script&lang=ts"
export * from "./TableComp.vue?vue&type=script&lang=ts"
import style0 from "./TableComp.vue?vue&type=style&index=0&id=0fbc1a6a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports